<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  bodyClass="!tw-pr-0 !tw-pl-2 tw-pt-5"
  [class]="
    isShowContactsNumberListForm ||
    isShowContactsNumberListForm ||
    isShowContactsImportFromXlsx
      ? 'd-none'
      : ''
  "
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onSelectAll)="onSelectAll($event)"
  display="flex !important"
>
  <div
    class="card-toolbar"
    after-btns
    *ngIf="selectedPhonebook.phonebookTypes != PhonebookTypes.ParentPublic"
  >
    <!-- new -->
    <a
      [matMenuTriggerFor]="menu"
      class="btn txt-lg button-shadow tw-mr-2 tw-flex tw-items-center"
      [themeColor]="'btn'"
      mat-ripple
    >
      <span class="tw-mx-1">{{ "common.new" | translate }}</span>
      <i class="mdi mdi-chevron-left mdi-18px tw-text-white"></i>
    </a>

    <mat-menu #menu="matMenu" xPosition="after">
      <!-- addSingle -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="showForm('create')"
      >
        <span class="tw-mx-1 text-primary">
          <i
            class="mdi mdi-plus-circle-outline mdi-24px text-primary tw-ml-2"
          ></i>
          {{ pageVocabs + "addBtns.addSingle" | translate }}
        </span>
      </a>
      <!-- addListNumber -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowContactsNumberList()"
      >
        <span class="tw-mx-1 text-primary">
          <i
            class="mdi mdi-text-box-plus-outline mdi-24px text-primary tw-ml-2"
          ></i>
          {{ pageVocabs + "addBtns.addListNumber" | translate }}
        </span>
      </a>
      <!-- addFromFile -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center"
        mat-ripple
        (click)="onShowImportContactsFromXlsx()"
      >
        <span class="tw-mx-1 text-primary">
          <i
            class="mdi mdi-file-account-outline mdi-24px text-primary tw-ml-2"
          ></i>
          {{ pageVocabs + "addBtns.addFromFile" | translate }}
        </span>
      </a>
    </mat-menu>
  </div>

  <div class="card-toolbar" before-btns>
    <!-- delete contacts form phonebooks btn -->

    <!-- groupDeletion btn -->
    <div
      *ngIf="selectedPhonebook.phonebookTypes != PhonebookTypes.ParentPublic"
      [matTooltip]="'common.groupDeletion' | translate"
    >
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>

    <!-- advanced search btn -->
    <div [matTooltip]="'messages.searchInContacts' | translate">
      <button
        (click)="onSearchContacts()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-magnify mdi-20px tw-p-0 text-primary"></i>
      </button>
    </div>

    <!-- download -->
    <div [matTooltip]="'common.download' | translate">
      <button
        (click)="downloadContactsGetApi()"
        [disabled]="
          contactCount == 0 || phonebookType == PhonebookTypes.ParentPublic
        "
        class="btn btn-light txt-lg button-shadow tw-mx-1 tw-mr-1 btn-hover-rise"
        type="button"
        mat-ripple
        style="width: 51px"
      >
        <i
          *ngIf="!downloadLoading"
          class="mdi mdi-download mdi-20px tw-p-0 text-success"
        ></i>
        <span
          *ngIf="downloadLoading"
          class="spinner-border spinner-border-sm text-success tw-mt-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-px-1 tw-text-center">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <td>
          <div class="form-check text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mr-0"
              (click)="onAddSelectedIdAndCellPhone($event, item, row)"
              [attr.data-checkbox-id]="item.id"
            />
          </div>
        </td>

        <!-- firstName -->
        <td>
          <td-value copyToClipboard [value]="item?.firstName"></td-value>
        </td>

        <!-- lastName -->
        <td>
          <td-value copyToClipboard [value]="item?.lastName"></td-value>
        </td>

        <!-- cellphone -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.cellPhone"
          ></td-value>
        </td>
        <!-- telephone -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.telephone"
          ></td-value>
        </td>

        <td class="tw-px-1">
          <span>
            {{ item?.createType | enumToText : CreateTypeEnumValues }}
          </span>
        </td>

        <!-- dateExit -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.dateExit"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.createdAt"
          ></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td
          class="sticky-td"
          *ngIf="
            selectedPhonebook.phonebookTypes != PhonebookTypes.ParentPublic
          "
        >
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="showForm('update', item?.id)"></div>

            <!-- delete button -->
            <div
                app-menu-btn
                icon="delete"
                (click)="onDelete(item.id, item?.cellPhone)">
            </div>

            <!-- delete all contacts button -->
            <div
                app-menu-btn
                icon="mdi mdi-table-large-remove mdi-20px"
                color="red"
                [title]=" pageVocabs + 'deleteContactsFormPhonebooks.title'"
                (click)="onShowDeleteContactsFromAllPhonebooks(item?.id)"
             >
            </div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-contacts-form
    [formPageConfig]="formPageConfig"
    [phonebookId]="phonebookId"
    [phonebookTitle]="phonebookTitle"
    [customFields]="customFields"
    (closeFormPage)="getFormResponse($event); emitIsShowContactsForm()"
  >
  </app-contacts-form>
</ng-container>

<!-- add contacts with number list -->
<ng-container *ngIf="isShowContactsNumberListForm">
  <app-contacts-number-list-form
    [selectedPhonebook]="selectedPhonebook"
    (closeFormPage)="
      getContactsNumberListFormResponse($event);
      emitIsShowContactsNumberListForm()
    "
    [phonebookTitle]="phonebookTitle"
  >
  </app-contacts-number-list-form>
</ng-container>

<!-- add contacts from xlsx file -->
<ng-container *ngIf="isShowContactsImportFromXlsx">
  <app-contacts-import-from-xlsx
    [customFields]="customFields"
    [selectedPhonebook]="selectedPhonebook"
    (closeFormPage)="
      getImportContactsFromXlsxResponse($event);
      emitIsShowContactsNumberListForm()
    "
    [phonebookTitle]="phonebookTitle"
  >
  </app-contacts-import-from-xlsx>
</ng-container>

<!--audits-->
<!-- <ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit [service]="currentService" methodName="contactsGetContactsAuditWithPagination"
    (hidePage)="onHideAuditPage()">
  </app-audit>
</ng-container> -->

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="Phonebook"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
